<template>
  <div
    class="instagramFeed notranslate">
    <div class="feeds"
      :style="feedGrid"
      :data-caption="setting.instagramfeed.caption">
      <div v-for="(feed, index) in feeds"
        :key="index"
        class="feedItem"
        @click="permalink(feed.permalink)">
        <div v-if="feed.media_url" class="thumb" :style="feedThumbnail(feed)"></div>
        <div v-if="feed.caption" class="caption">{{ feed.caption }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Instagramfeed',
  props: [
    'setting',
    'locale'
  ],
  computed: {
    feeds () {
      const max = parseInt(this.setting.instagramfeed.items)
      return this.feedList && this.feedList.filter((x, i) => i < max)
    },
    feedGrid () {
      const cols = this.setting.instagramfeed.cols
      const margin = this.setting.instagramfeed.margin
      return {
        'grid-template-columns': `repeat(${cols}, 1fr)`,
        'row-gap': `${margin}px`,
        'column-gap': `${margin}px`
      }
    }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      accessToken: null,
      feedList: null
    }
  },
  methods: {
    init () {
      this.$store.dispatch('thirdparty/getAccessToken', 'instagram').then((res) => {
        if (res && res.access_token) {
          const accessToken = res.access_token
          this.accessToken = accessToken
          this.getFeeds(accessToken)
        } else {
          alert(this.locale.alert_system_error)
        }
      })
    },
    getFeeds (accessToken) {
      this.$store.dispatch('thirdparty/getInstagramFeed', { accessToken: accessToken }).then((res) => {
        if (res && res.data) {
          this.feedList = res.data
        }
      })
    },
    feedThumbnail (feed) {
      const isVideo = feed.media_type === 'VIDEO'
      const thumb = isVideo ? feed.thumbnail_url : feed.media_url
      return {
        background: thumb ? `url("${thumb}") 50% 50% / cover no-repeat` : null
      }
    },
    permalink (link) {
      window.open(link)
    }
  }
}
</script>
